export default __webpack_public_path__ + "static/media/1_Still.7e913a1b.jpg";